import { mergeAttributes, Node } from "@tiptap/core";
import { wrappingInputRule } from "prosemirror-inputrules";

export interface DashedListOptions {
  itemTypeName: string;
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    dashedList: {
      /**
       * Toggle a dashed list
       */
      toggleDashedList: () => ReturnType;
    };
  }
}

export const inputRegex = /^\s*([-+*])\s$/;

const DashedList = Node.create<DashedListOptions>({
  name: "dashedList",

  addOptions() {
    return {
      itemTypeName: "dashedItem",
      HTMLAttributes: {},
    };
  },

  group: "block list",

  content() {
    return `${this.options.itemTypeName}+`;
  },

  parseHTML() {
    return [
      {
        tag: `ul`,
        priority: 51,
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "ul",
      mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, {
        "data-type": this.name,
      }),
      0,
    ];
  },

  addCommands() {
    return {
      toggleDashedList:
        () =>
        ({ commands }) => {
          return commands.toggleList(this.name, this.options.itemTypeName);
        },
    };
  },

  addKeyboardShortcuts() {
    return {
      "Mod-Shift-6": () => this.editor.commands.toggleDashedList(),
    };
  },

  addInputRules() {
    return [wrappingInputRule(inputRegex, this.type)];
  },
});

export default DashedList;
